import axios from 'axios';
import {withoutComma} from "../../../utils/calculate/Amount";

export class CaptureGuaranteesService {
    /**
     * Función que obtiene la lista de posiciones para la pantalla principal
     * de captura de garantias
     * @returns {Promise<List>} Lista con las posiciones
     */
    getGuaranteePosition() {
        return axios.get('/appapv/getGuaranteePosition.action', {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(res => res.data.payload);
    }

    /**
     * Función que se ejecuta cuando se guarda la posición
     * @param positionObject Objeto que contiene la información de la posición.
     * @returns {Promise<unknown>}
     */
    saveEmisora(positionObject) {
        return axios.post('/appapv/saveEmisora.action', {}, {
            params: {
                cupon: positionObject.cupon,
                isin: positionObject.isin,
                fechaVence: positionObject.fechaVence,
                cantidadTitulos: positionObject.cantidadTitulos ?
                    withoutComma(positionObject.cantidadTitulos) : '1',
                cuenta: positionObject.cuenta ? positionObject.cuenta : '',
                emisora: encodeURIComponent((positionObject.emisora)),
                serie: encodeURIComponent((positionObject.serie)),
                tipoValor: encodeURIComponent((positionObject.tipoValor))
            }
        }).then(res => res.data);
    }

    /**
     * Función que obtiene información extra de la posición para editarla
     * @param idEmission
     * @param account
     * @returns {Promise<unknown>}
     */
    getPositionAccountEmisora(idEmission, account) {
        return axios.get('/appapv/getPositionAccountEmisora.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                idEmision: idEmission,
                cuenta: account,
            }
        }).then(res => res.data.payload);
    }

    /**
     * Función que guarda la posición cuando se edita.
     * @param positionData Objeto que contiene la información de la posición
     * @returns {Promise<unknown>}
     */
    saveMttoPosition(positionData) {
        return axios.post('/appapv/saveMttoPosition.action', {}, {
            params: {
                idEmision: positionData.idEmision,
                cuenta: positionData.cuenta,
                posicion: positionData.posicion,
                disponibleGarantias: positionData.disponibleGarantia,
            }
        }).then(res => res.data);
    }

    /**
     * Función que elimina una posición.
     * @param idEmission
     * @param account
     * @returns {Promise<unknown>}
     */
    deletePosition(idEmission, account) {
        return axios.delete('/appapv/deletePosition.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                idEmision: idEmission,
                cuenta: account,
            }
        }).then(res => res.data);
    }
}